import { render, staticRenderFns } from "./manageHolidays.vue?vue&type=template&id=11e9bb89&"
import script from "./manageHolidays.vue?vue&type=script&lang=js&"
export * from "./manageHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports